<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-right">
<!--        <button type="button" @click="openRacksModal('node')" class="btn btn-primary">Add new node</button>-->
        <button type="button" @click="openRacksModal('rack')" class="btn btn-primary">Add new rack</button>
      </div>

    </div>
    <div v-if="!loading">
      <div class="row" >
        <div v-for="(row1, index1) in allRacks" :key="index1" class="col-md-3">
          <div class="card" style="height: 277px">

            <div style="display: flex; align-items: center; padding: 0">
              <h6 class=" col-md-10">{{row1.name}}</h6>
              <span @click="openNodesModal(row1)" class="details-control col-md-2"></span>
            </div>
            <perfect-scrollbar class="scroll-area">
            <ul class="list-group">
              <li v-for="(row2,index2) in row1.nodes" :key="index2" class="list-group-item">
                {{row2.nodeFname}}
              </li>

            </ul>
            </perfect-scrollbar>
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

export default {
  name: "Racks",
  components: {

    PerfectScrollbar
  },
  data() {
    return {
      allRacks: [],
      loading: false,
      allNodes: []
    }
  },

  computed: {

  },
  mounted(){
    this.getAllRacks();


  },
  methods: {
    openNodesModal(row){
      this.$parent.$refs.nodes.load(row)
    },
    openRacksModal(val){
      this.$parent.$refs.racks.load(val)
    },
    async getAllNodes(){
      this.allNodes=[];
      this.loading=true
      const nodesResp= await db.collection('nodes').get();
      nodesResp.forEach(el => {

        this.allNodes.push({id: el.id, ...el.data()});
      })
      this.loading=false;
    },
    async getAllRacks(){
      this.allRacks=[]
      this.loading=true
      await this.getAllNodes();
      console.log(this.allNodes)
      const rackResp= await db.collection('racks').orderBy('created', "desc").get();
      rackResp.forEach(el => {
        let nodes=this.allNodes.filter(el1 => {
          return el1.rackId && el1.rackId === el.id
        })
        if(nodes.length){
          this.allRacks.push({id: el.id, ...el.data(), nodes});

        }
        else{
          this.allRacks.push({id: el.id, ...el.data()});

        }
      })
      console.log(this.allRacks)
      this.loading=false;

    },


  }
}
</script>
<style scoped>
h6{
  margin-top: 9px;
}
.list-group-item:focus, .list-group-item:hover{
  z-index: 0!important;
}
</style>

